// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD0OwjXkkDzaE5VC8kyHxDi1-S6ddXcJAQ",
  authDomain: "live-flight-tracker---web.firebaseapp.com",
  projectId: "live-flight-tracker---web",
  storageBucket: "live-flight-tracker---web.firebasestorage.app",
  messagingSenderId: "477853082081",
  appId: "1:477853082081:web:4ae17bf34cb96b447472a0",
  measurementId: "G-N6GJX3YQYT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);
if (typeof window !== 'undefined') {
  setPersistence(auth, browserLocalPersistence).catch(() => {});
}

// Initialize Firestore Database
export const db = getFirestore(app);

// Initialize Firebase Functions
export const functions = getFunctions(app);

// Initialize Firebase Messaging
export let messaging = null;
if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
    }
  });
}

// Initialize Analytics immediately for PWA tracking
export let analytics = null;
if (typeof window !== 'undefined') {
  // Initialize Analytics immediately
  import('firebase/analytics').then(({ getAnalytics }) => {
    try {
      analytics = getAnalytics(app);
      console.log('✅ Firebase Analytics initialized');
    } catch (error) {
      console.warn('❌ Firebase Analytics initialization failed:', error);
    }
  }).catch((error) => {
    console.warn('❌ Firebase Analytics import failed:', error);
  });
}

// Export the initialized app for other Firebase services (e.g., Remote Config)
export const firebaseApp = app;